/* SmartPaw — afhaakvraag
   ----------------------
   Eén vraag aan wie de checkout verliet zonder te bestellen.

   Wanneer hij verschijnt — alle vier moeten kloppen:
     1. Ze klikten op de afrekenknop (vlag in sessionStorage), OF ze komen
        rechtstreeks van de checkout terug (document.referrer).
     2. De winkelwagen is niet leeg. Shopify leegt hem pas bij een geslaagde
        bestelling, dus dit sluit kopers vanzelf uit.
     3. Nog niet getoond deze sessie.
     4. Niet getoond in de laatste 30 dagen.

   Waar het antwoord heen gaat: als eigen meetpunt 'Checkout Survey' naar
   Klaviyo, met de reden, de toelichting, het winkelwagenbedrag, de taal en
   de bron. Alleen als de bezoeker analytische cookies heeft toegestaan.

   Bewust géén scrollvergrendeling en géén achtergrondlaag. Zie de CSS.

   Handmatig bekijken: zet ?sps=1 achter een URL van de winkel.
*/
(function () {
  'use strict';

  var WACHT_MS      = 1200;            /* na het laden */
  var VLAG_GELDIG   = 30 * 60 * 1000;  /* een klik op afrekenen telt 30 min */
  var HERHAAL_DAGEN = 30;
  var SLEUTEL_SESSIE = 'sp_survey_v1_sessie';
  var SLEUTEL_LAATST = 'sp_survey_v1_laatst';
  var SLEUTEL_VLAG   = 'sp_checkout_klik';

  var wrap = document.querySelector('[data-sps]');
  if (!wrap) return;

  var bron = 'popup';

  /* ---------- kleine hulpjes ---------- */

  function lees(store, sleutel) {
    try { return window[store].getItem(sleutel); } catch (e) { return null; }
  }
  function schrijf(store, sleutel, waarde) {
    try { window[store].setItem(sleutel, waarde); } catch (e) {}
  }
  function wis(store, sleutel) {
    try { window[store].removeItem(sleutel); } catch (e) {}
  }

  function mag_meten() {
    /* Respecteert de cookiebanner. Kent de bezoeker de vraag niet, dan meten
       we niet, maar tonen we hem wel — de vraag zelf is geen tracking. */
    try {
      var p = window.Shopify && window.Shopify.customerPrivacy;
      if (p && typeof p.analyticsProcessingAllowed === 'function') {
        return p.analyticsProcessingAllowed() === true;
      }
    } catch (e) {}
    return true;
  }

  /* ---------- vlag zetten zodra ze afrekenen ---------- */

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var knop = e.target.closest(
      'button[name="checkout"], input[name="checkout"], #CheckOut, a[href$="/checkout"], a[href*="/checkout?"]'
    );
    if (knop) schrijf('sessionStorage', SLEUTEL_VLAG, String(Date.now()));
  }, true);

  /* ---------- tonen en sluiten ---------- */

  var zichtbaar = false;

  function stap(n) {
    var blokken = wrap.querySelectorAll('[data-sps-step]');
    for (var i = 0; i < blokken.length; i++) {
      blokken[i].hidden = blokken[i].getAttribute('data-sps-step') !== String(n);
    }
  }

  function toon() {
    if (zichtbaar) return;
    zichtbaar = true;
    wrap.hidden = false;
    /* eerst tekenen, dan pas de klasse — anders is er geen overgang */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { wrap.classList.add('is-in'); });
    });
    schrijf('sessionStorage', SLEUTEL_SESSIE, '1');
    schrijf('localStorage', SLEUTEL_LAATST, String(Date.now()));
  }

  function sluit() {
    zichtbaar = false;
    wrap.classList.remove('is-in');
    window.setTimeout(function () { wrap.hidden = true; }, 280);
  }

  /* ---------- antwoord wegschrijven ---------- */

  var gekozen = '';
  var bedrag  = 0;

  function bewaar(toelichting) {
    if (!gekozen) return;
    if (!mag_meten()) return;
    try {
      var kl = window.klaviyo || window._learnq;
      if (kl && typeof kl.push === 'function') {
        var lading = {
          reden:       gekozen,
          toelichting: toelichting || '',
          taal:        wrap.getAttribute('data-sps-lang') || '',
          bron:        bron
        };
        /* Alleen meesturen als we het bedrag echt kennen. Een 0 zou de
           gemiddelden vertekenen bij wie vanuit de mail antwoordt met een
           lege winkelwagen op een ander toestel. */
        if (bedrag > 0) lading.waarde = bedrag;
        kl.push(['track', 'Checkout Survey', lading]);
      }
    } catch (e) {
      if (window.console) window.console.warn('[SmartPaw survey]', e);
    }
  }

  /* ---------- knoppen ---------- */

  var opties = wrap.querySelectorAll('[data-sps-val]');
  for (var i = 0; i < opties.length; i++) {
    (function (btn) {
      btn.setAttribute('aria-pressed', 'false');
      btn.addEventListener('click', function () {
        for (var j = 0; j < opties.length; j++) {
          opties[j].setAttribute('aria-pressed', 'false');
        }
        btn.setAttribute('aria-pressed', 'true');
        gekozen = btn.getAttribute('data-sps-val') || '';
        window.setTimeout(function () {
          stap(2);
          var ta = wrap.querySelector('[data-sps-text]');
          if (ta) { try { ta.focus({ preventScroll: true }); } catch (e) { ta.focus(); } }
        }, 170);
      });
    })(opties[i]);
  }

  var verstuur = wrap.querySelector('[data-sps-send]');
  if (verstuur) {
    verstuur.addEventListener('click', function () {
      var ta = wrap.querySelector('[data-sps-text]');
      bewaar(ta ? ta.value.slice(0, 500) : '');
      stap(3);
      if (bron === 'popup') window.setTimeout(sluit, 3200);
    });
  }

  var sluiters = wrap.querySelectorAll('[data-sps-close]');
  for (var k = 0; k < sluiters.length; k++) {
    sluiters[k].addEventListener('click', function () {
      /* Antwoord zonder toelichting is ook een antwoord. */
      if (gekozen) bewaar('');
      sluit();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && zichtbaar) { if (gekozen) bewaar(''); sluit(); }
  });

  /* Gaan ze alsnog afrekenen terwijl de vraag openstaat, dan gaan we opzij. */
  document.addEventListener('click', function (e) {
    if (!zichtbaar || !e.target || !e.target.closest) return;
    if (wrap.contains(e.target)) return;
    if (e.target.closest('button[name="checkout"], #CheckOut, a[href*="/checkout"]')) sluit();
  }, true);

  function haalBedrag() {
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart && cart.total_price) bedrag = cart.total_price; })
      .catch(function () {});
  }

  /* ---------- landing vanuit de mail: ?sp_a=<reden> ---------- */

  function uitDeMail() {
    var m = window.location.search.match(/[?&]sp_a=([a-z_]{2,30})/i);
    if (!m) return false;
    bron = 'mail';
    gekozen = m[1].toLowerCase();
    wrap.classList.add('sps--page');
    wrap.hidden = false;
    wrap.classList.add('is-in');
    zichtbaar = true;
    stap(2);
    /* Staat hun winkelwagen er nog op dit toestel, dan nemen we het bedrag mee. */
    haalBedrag();
    return true;
  }

  /* ---------- beslissen of hij mag verschijnen ---------- */

  function magTonen() {
    if (/[?&]sps=1(&|$)/.test(window.location.search)) return true;

    if (lees('sessionStorage', SLEUTEL_SESSIE)) return false;

    var laatst = parseInt(lees('localStorage', SLEUTEL_LAATST) || '0', 10);
    if (laatst && (Date.now() - laatst) < HERHAAL_DAGEN * 864e5) return false;

    var vlag = parseInt(lees('sessionStorage', SLEUTEL_VLAG) || '0', 10);
    var recent = vlag > 0 && (Date.now() - vlag) < VLAG_GELDIG;

    var ref = document.referrer || '';
    var viaCheckout = /\/checkouts?\//.test(ref) ||
                      ref.indexOf('shop.app') > -1 ||
                      ref.indexOf('checkout.shopify.com') > -1 ||
                      ref.indexOf('pay.shopify.com') > -1;

    return recent || viaCheckout;
  }

  function start() {
    if (uitDeMail()) return;
    if (!magTonen()) return;

    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        if (!cart.item_count) {
          /* Leeg betekent besteld of leeggemaakt — vlag weg, niets vragen. */
          wis('sessionStorage', SLEUTEL_VLAG);
          return;
        }
        bedrag = cart.total_price || 0;
        window.setTimeout(toon, WACHT_MS);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
